import { render, staticRenderFns } from "./LanceKit.vue?vue&type=template&id=87f2ce50&"
import script from "./LanceKit.vue?vue&type=script&lang=js&"
export * from "./LanceKit.vue?vue&type=script&lang=js&"
import style0 from "./LanceKit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports